<template>
  <div class="form-check" :class="[{ disabled: disabled }, inlineClass]">
    <label :for="cbId" class="form-check-label">
      <input
        :id="cbId"
        v-model="model"
        type="checkbox"
        class="form-check-input"
        :disabled="disabled"
        :value="value"
        autocomplete="off"
      />
      <span class="form-check-sign"></span>
      <slot><span v-if="inline">&nbsp;</span></slot>
    </label>
  </div>
</template>
<script>
export default {
  name: "n-checkbox-button",
  data() {
    return {
      cbId: "",
      touched: false,
    };
  },
  props: {
    disabled: Boolean,
    inline: {
      type: Boolean,
      description: "Whether button is outlined (only border has color)",
    },
    type: String,
    value: {
      type: [Boolean, Number, String],
      description: "Checked value",
    },
    options: {
      type: [Boolean, Number, String, Array],
    },
    buttonClasses: {
      type: [String, Object],
      description: "Inner button css classes",
    },
  },
  model: {
    prop: "options",
    event: "change",
  },
  computed: {
    model: {
      get() {
        return this.options;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
      return "";
    },
  },
  created() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2);
  },
};
</script>
<style></style>
